import client from '../client'

export interface UpdateVendorProfileResponse extends Response {
	data: {
		vendor_no: string
	}
}

export type UpdateVendorProfilePayload = {
	profile_img?: string
	background_img?: string | null
	name?: string
	vendor_store_link?: string
	company_description?: string
	company_name?: string
	ceo_name?: string
	address?: string
	email?: string
	phone?: string
	vendor_contacts?: {
		no?: string
		name?: string
		position?: string
		email?: string
		phone?: string
	}[]
}

export const updateVendorProfile = async (
	vendorNo: string,
	payload: UpdateVendorProfilePayload,
): Promise<UpdateVendorProfileResponse> => {
	const response = await client.patch<UpdateVendorProfileResponse>(`vendors/${vendorNo}`, payload)

	return response.data
}
